import React from "react";
import ConfirmationPopUpModalComponent from "../../components/Std/ConfirmationPopUpModal/ConfirmationPopUpModalComponent";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import { useSelector, useDispatch } from "react-redux";
import ChangePasswordComponent from "../../components/Settings/ChangePasswordComponent";
import PropTypes from "prop-types";

const ChangePassword = (props, context) => {
  const dispatch = useDispatch();

  const modalAction = bindActionCreators(modalActions, dispatch);

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  return (
    <ChangePasswordComponent
      closeRemoveModal={closeRemoveModal}
      {...props}
      context={context}
    />
  );
};
ChangePassword.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default ChangePassword;
